import { useState } from 'react';
import { Input, message } from 'antd';
import { EditOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Service } from '../../../service';
import './style.scss';

export default function EditableCell({ value, fieldKey, quotationId, token, onUpdate }) {
	const [isEditing, setIsEditing] = useState(false);
	const [editValue, setEditValue] = useState(value);
	const [isLoading, setIsLoading] = useState(false);

	const handleEdit = () => {
		setEditValue(value);
		setIsEditing(true);
	};

	const handleCancel = () => {
		setEditValue(value);
		setIsEditing(false);
	};

	const buildBody = (fieldKey, newValue) => {
		if (fieldKey === 'name') {
			const parts = newValue.trim().split(/\s+/);
			const firstName = parts[0] || '';
			const lastName = parts.slice(1).join(' ') || '';
			return { first_name: firstName, last_name: lastName };
		}
		return { [fieldKey]: newValue };
	};

	const handleConfirm = async () => {
		if (editValue === value) {
			setIsEditing(false);
			return;
		}

		setIsLoading(true);
		try {
			const body = buildBody(fieldKey, editValue);
			await new Service().updateUserInfo(body, quotationId, token);
			onUpdate(fieldKey, editValue);
			setIsEditing(false);
			message.success('Dato actualizado correctamente');
		} catch (error) {
			console.error('Error updating user info:', error);
			message.error('Error al actualizar el dato');
		} finally {
			setIsLoading(false);
		}
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			handleConfirm();
		} else if (e.key === 'Escape') {
			handleCancel();
		}
	};

	if (isEditing) {
		return (
			<div className="editable-cell-input-wrapper">
				<Input
					size="small"
					value={editValue}
					onChange={(e) => setEditValue(e.target.value)}
					onKeyDown={handleKeyDown}
					disabled={isLoading}
					autoFocus
				/>
				<CheckOutlined
					className="editable-cell-icon-check"
					onClick={handleConfirm}
				/>
				<CloseOutlined
					className="editable-cell-icon-close"
					onClick={handleCancel}
				/>
			</div>
		);
	}

	return (
		<div className="editable-cell-value-wrapper">
			<span>{value}</span>
			<EditOutlined
				className="editable-cell-icon-edit"
				onClick={handleEdit}
			/>
		</div>
	);
}
